import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  blogList: [],
  blogListByCategory: [],
  isLoading: false,
  isBlogHeaderListLoading: false,
  isCategoriesLoading: false,
  error: null,
  isError: false,
  blogListHeader: [],
  updateBlogList: [],
  searchBlogList: [],
  isUpdateBlogListLoading: false,
  isSearchBlogListLoading: false,
};

export const blogListRedux = createSlice({
  name: "blogListRedux",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },

    setBlogListState: (state, action) => {
      const newState = {
        ...state,
      };
      if (action?.payload?.key) {
        newState[action.payload.key] = action.payload.value;
      }
      return newState;
    },

    // Blog List for Header
    getBlogListForHeaderRequest: (state) => {
      const newState = {
        ...state,
        isBlogHeaderListLoading: true,
        blogListHeader: [],
        isError: false,
        error: false,
      };

      return newState;
    },

    getBlogListForHeaderSuccess: (state, action) => {
      const newState = {
        ...state,
        blogListHeader: action?.payload,
        isBlogHeaderListLoading: false,
        error: null,
        isError: false,
      };

      return newState;
    },

    getBlogListForHeaderFailure: (state, action) => {
      const newState = {
        ...state,
        isBlogHeaderListLoading: false,
        isError: true,
        error: action.payload,
      };

      return newState;
    },

    getBlogListRequest: (state, action) => {
      let currentSlug = current(state.blogList)?.blogs?.[0]?.category?.name;
      const blogsListUpdate =
        action?.payload?.categorySlug === "" ||
        currentSlug === action?.payload?.categorySlug
          ? {}
          : { blogList: [] };
      const newState = {
        ...state,
        isLoading: true,
        // blogList: [],
        ...blogsListUpdate,
        isError: false,
        error: false,
      };

      return newState;
    },

    getBlogListSuccess: (state, action) => {
      const newState = {
        ...state,
        blogList: action?.payload,
        isLoading: false,
        error: null,
        isError: false,
      };

      return newState;
    },

    getBlogListFailure: (state, action) => {
      const newState = {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };

      return newState;
    },

    // Blog List By Category
    getBlogListByCategoryRequest: (state) => {
      const newState = {
        ...state,
        isLoading: true,
        blogListByCategory: [],
        isError: false,
        error: false,
      };

      return newState;
    },

    getBlogListByCategorySuccess: (state, action) => {
      const newState = {
        ...state,
        blogListByCategory: action?.payload?.categories,
        isLoading: false,
        error: null,
        isError: false,
      };

      return newState;
    },

    getBlogListByCategoryFailure: (state, action) => {
      const newState = {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };

      return newState;
    },

    // Blog List for updates
    getBlogListForUpdatesRequest: (state) => {
      const newState = {
        ...state,
        isUpdateBlogListLoading: true,
        isError: false,
        error: false,
      };

      return newState;
    },

    getBlogListForUpdatesSuccess: (state, action) => {
      const newState = {
        ...state,
        updateBlogList: action?.payload,
        isUpdateBlogListLoading: false,
        error: null,
        isError: false,
      };

      return newState;
    },

    getBlogListForUpdatesFailure: (state, action) => {
      const newState = {
        ...state,
        isUpdateBlogListLoading: false,
        isError: true,
        error: action.payload,
        updateBlogList: [],
      };

      return newState;
    },

    // Blog List for Search
    getBlogSearchListRequest: (state) => {
      const newState = {
        ...state,
        isSearchBlogListLoading: true,
        searchBlogList: [],
        isError: false,
        error: false,
      };

      return newState;
    },

    getBlogSearchListSuccess: (state, action) => {
      const newState = {
        ...state,
        searchBlogList: action?.payload,
        isSearchBlogListLoading: false,
        error: null,
        isError: false,
      };

      return newState;
    },

    getBlogSearchListFailure: (state, action) => {
      const newState = {
        ...state,
        isSearchBlogListLoading: false,
        isError: true,
        error: action.payload,
      };

      return newState;
    },
  },
});

export const {
  resetState,
  setBlogListState,

  getBlogListForHeaderRequest,
  getBlogListForHeaderSuccess,
  getBlogListForHeaderFailure,
  getBlogListRequest,
  getBlogListSuccess,
  getBlogListFailure,
  getBlogListByCategoryRequest,
  getBlogListByCategorySuccess,
  getBlogListByCategoryFailure,
  getBlogListForUpdatesRequest,
  getBlogListForUpdatesSuccess,
  getBlogListForUpdatesFailure,
  getBlogSearchListRequest,
  getBlogSearchListSuccess,
  getBlogSearchListFailure,
} = blogListRedux.actions;

export default blogListRedux.reducer;
